import { Avatar, Button, Heading, Text } from '@praetoid/ui';
import { createFileRoute, useRouter } from '@tanstack/react-router';

import {
	getListPraetorsQueryKey,
	getUserQueryKey,
	useListOrganizations,
	useSelectOrganization
} from '@praetoid/client';

import { queryClient } from '~/lib/queryClient';

export const Route = createFileRoute('/_onboarding/orgs/')({
	component: RouteComponent
});

function RouteComponent() {
	const { data: organizations } = useListOrganizations();
	const router = useRouter();

	const { mutateAsync: selectOrganization } = useSelectOrganization();

	const selectedOrganization = async (organization_id: string) => {
		await selectOrganization({ data: { organization_id } });
		await queryClient.refetchQueries({ queryKey: getListPraetorsQueryKey() });
		await queryClient.refetchQueries({ queryKey: getUserQueryKey() });
		await router.navigate({ to: '/' });
	};

	return (
		<div className="ui-gradient grid h-screen grid-cols-[1fr_440px_1fr] grid-rows-1 p-4">
			<div
				className="relative flex h-full items-center justify-center"
				style={{ gridColumnStart: 2 }}
			>
				<div className="ui-radial-gradient flex w-full flex-col gap-6 rounded-md border p-12">
					<Heading>Your Organizations</Heading>
					<div className="flex flex-col overflow-hidden rounded-lg border">
						{organizations?.map((organization) => (
							<Button
								size="4"
								key={organization.id}
								variant="ghost"
								className="m-0 justify-start"
								onClick={() => selectedOrganization(organization.id)}
							>
								<Avatar radius="full" fallback={organization.name.charAt(0)} />
								<Text>{organization.name}</Text>
							</Button>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
